import React from 'react'
import Resetpasswordpage from '../Components/Signup/Resetpassword'

const Resetpassword = () => {
  return (
   <Resetpasswordpage/>
  )
}

export default Resetpassword